/**
 * The website form types. Each is stored as-is in contacts.lead_source,
 * contacts.latest_lead_source and lead_submissions.form_type.
 * Keep identical to the list hardcoded in the capture_lead SQL function.
 */
export const leadFormTypes = [
  "Book Demo",
  "Contact Sales",
  "Schedule Demo",
  "Newsletter",
  "Partner Apply",
  "Chatbot",
  "Trust Center",
] as const;

export type LeadFormType = (typeof leadFormTypes)[number];

export const leadSourceChoices = leadFormTypes.map((formType) => ({
  id: formType,
  name: formType,
}));

export const leadStatusChoices = [
  { value: "lead", label: "Lead" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "customer", label: "Customer" },
  { value: "disqualified", label: "Disqualified" },
];

/** Lead attribution columns handled by the contacts CSV export and import. */
export const leadImportFields = [
  "lead_source",
  "latest_lead_source",
  "lead_campaign",
  "product_interest",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "landing_page",
] as const;
